import { render, staticRenderFns } from "./FlyerModal.vue?vue&type=template&id=64545db3&scoped=true&"
import script from "./FlyerModal.vue?vue&type=script&lang=js&"
export * from "./FlyerModal.vue?vue&type=script&lang=js&"
import style0 from "./FlyerModal.vue?vue&type=style&index=0&id=64545db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64545db3",
  null
  
)

export default component.exports